import { mapValues, get, isArray } from "lodash";
import { FormState } from "final-form";
import { EMAIL_REGEXP } from "constants/validation";

export const comparisonValues = (fieldName: string) => (str2: string, values: any): string | undefined => {
  if (values[fieldName] !== str2) {
    return "Validation.PasswordsDontMatch.Error";
  }
}

export const hasUpperCase = (str: string): string | undefined => {
  if (!/[A-Z]/.test(str)) {
    return "Validation.HasUpperCase.Error";
  }
}

export const hasRequiredLength = (length: number) => (str: string | any[]) => {
  const value = str || '';

  if (value.length < length) {
    return "Validation.HasRequiredLength.Error";
  }
};


export const hasRequiredMaxLength = (length: number) => (str: string | any[]) => {
  const value = str || '';

  if (value.length > length) {
    return `This field should be shorter than ${length}`;
  }
};


export const hasRequired = (value: any) => {
  // Accept non-empty strings, non-empty arrays, valid Date objects, truthy booleans, and non-empty objects.
  if (value == null) return "This field is required";

  if (value instanceof Date) {
    return isNaN(value.getTime()) ? "This field is required" : undefined;
  }

  if (typeof value === "string") {
    return value.trim().length > 0 ? undefined : "This field is required";
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? undefined : "This field is required";
  }

  if (typeof value === "object") {
    return Object.keys(value).length > 0 ? undefined : "This field is required";
  }

  if (typeof value === "boolean") {
    return value ? undefined : "This field is required";
  }

  // Fallback: treat truthy as filled.
  return value ? undefined : "This field is required";
};

export const hasValidEmail = (str: string) => {
  if (!EMAIL_REGEXP.test(str)) {
    return "Validation.IncorrectEmail.Error";
  }
};

export const compose = (...validators: (any | undefined | false | '')[]) => (value: any, values: any) => {
  return validators.reduce((error: any, validator) => error || (validator ? validator(value, values) : undefined), undefined);
}

export const structuredValidator = (structure: any) => {
  return function validate(values: any, description: any = structure): {[key: string]: string | undefined} {
    return mapValues(description, (item: any, name: any) => {

      if (typeof item === 'function') {
        return item(values[name], values);
      }
      if (isArray(item)) {
        return item.map((nestedValidator: any, index: any) => {
          return nestedValidator(get(values[name], index));
        });
      } else if (item && typeof item === 'object') {
        if (values[name]) {
          return validate(values[name], item);
        }
        const initialNestedValue = {
          [name]: undefined
        };
        return validate(initialNestedValue, item);
      }
    });
  };
};

export const isShowInputError = <T>(props: FormState<T>, fieldName: string) => {
  const { errors, submitFailed, dirtyFieldsSinceLastSubmit } = props;
  return errors && errors[fieldName] && submitFailed && !dirtyFieldsSinceLastSubmit[fieldName];
}

export const isNotObjectEmpty = (obj: Record<any, any>): string | undefined => {
  if (!(obj && Object.entries(obj).length > 0)) {
    return "Object is empty.";
  }
}
